module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/mv-51bff6efceef8e17a0a137ae5ad3b15f.png";